import { apiClient } from '../../../shared/api/client.js';
import type { ScanRecord } from '../../../shared/types/index.js';

export const scannerApi = {
  async recordScan(
    uibn: string,
    scanMethod: 'barcode_scanner' | 'qr_scanner' | 'manual_input',
    bookId?: string
  ): Promise<{ message: string; record: ScanRecord }> {
    return apiClient('/api/scans', {
      method: 'POST',
      body: JSON.stringify({ uibn, scanMethod, bookId }),
    });
  },

  async getScanHistory(limit: number = 50, offset: number = 0): Promise<{ history: any[]; total: number; limit: number; offset: number }> {
    return apiClient(`/api/scans/history?limit=${limit}&offset=${offset}`);
  },
};
